module.exports = __webpack_public_path__ + "img/bfc-building.3aad71f8.jpg";